import { render, staticRenderFns } from "./LoginClubInformation.vue?vue&type=template&id=a4e810c6"
import script from "./LoginClubInformation.vue?vue&type=script&lang=ts"
export * from "./LoginClubInformation.vue?vue&type=script&lang=ts"
import style0 from "./LoginClubInformation.vue?vue&type=style&index=0&id=a4e810c6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports